/* eslint-disable array-callback-return */
import * as actionTypes from "./actionTypes";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import { getErrorStringFromServerError } from "@icarius-localization/strings";
import {
  getTransactionLogAPI,
  searchTransactionLogAPI,
} from "@icarius-connection/api";

export const getTransactionLogAction = () => async (dispatch) => {
  dispatch({ type: actionTypes.GET });
  try {
    let response = await getTransactionLogAPI();
    let data = response.data && response.data.data;

    dispatch({
      type: actionTypes.GET_FULFILLED,
      payload: { data },
    });
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.GET_REJECTED, payload: e });
    dispatch(openSnackbarAction({ msg: getErrorStringFromServerError(e), severity: "error" }));
  }
};

export const searchTransactionLogAction = (query) => async (dispatch) => {
  dispatch({ type: actionTypes.SEARCH });
  try {
    let response = await searchTransactionLogAPI(`?token=${query}`);

    dispatch({
      type: actionTypes.SEARCH_FULFILLED
    });
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.SEARCH_REJECTED, payload: e });
    dispatch(openSnackbarAction({ msg: getErrorStringFromServerError(e), severity: "error" }));
  }
};